// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filters-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: flex-start;
  margin-bottom: 1.5rem;
}
.filters-container .filter-item {
  display: flex;
  flex-direction: row;
  min-width: 200px;
  flex: 1;
  max-width: 300px;
  justify-content: flex-start;
  align-items: baseline;
}
.filters-container .filter-item .filter-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #495057;
  margin-bottom: 0.25rem;
  white-space: nowrap;
}
.filters-container .filter-item .form-control {
  height: 38px;
}
.filters-container .filter-item .select {
  display: flex;
  align-items: stretch;
}
.filters-container .filter-item .select mdb-select-2 {
  height: 38px;
  width: 100%;
  min-width: 160px;
  display: inline-block;
}
.filters-container .filter-item .select mdb-select-2 .select-wrapper {
  margin-bottom: 0;
  height: 38px;
  display: flex;
  align-items: stretch;
}
.filters-container .filter-item .select mdb-select-2 .form-control {
  height: 38px;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  line-height: 1.5;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
}
.filters-container .filter-item .select mdb-select-2 .mdb-select-arrow,
.filters-container .filter-item .select mdb-select-2 .mdb-select-toggle {
  height: calc(100% - 2px);
  top: 1px;
  right: 1px;
  border-left: 1px solid #ced4da;
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.filters-container .filter-item .select mdb-select-2 .mdb-select-arrow::before,
.filters-container .filter-item .select mdb-select-2 .mdb-select-toggle::before {
  content: "\\f107";
  font-family: "Font Awesome 5 Free", ui-rounded;
  font-weight: 900;
  color: #6c757d;
  font-size: 14px;
}
@media (max-width: 768px) {
  .filters-container .filter-item {
    min-width: 150px;
    max-width: 100%;
  }
}
@media (max-width: 576px) {
  .filters-container .filter-item {
    min-width: 100%;
    max-width: 100%;
  }
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}
.dashboard-header h1 {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 600;
}

.filter-tabs {
  margin-bottom: 1.5rem;
}
.filter-tabs .nav-tabs {
  border-bottom: 1px solid #dee2e6;
}
.filter-tabs .nav-tabs .nav-link {
  cursor: pointer;
  color: #495057;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  padding: 0.75rem 1.25rem;
  font-weight: 500;
}
.filter-tabs .nav-tabs .nav-link:hover {
  border-color: #e9ecef #e9ecef #dee2e6;
}
.filter-tabs .nav-tabs .nav-link.active {
  color: #007bff;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}

.search-filter-bar {
  background-color: #f8f9fa;
  padding: 1.25rem;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.batch-actions {
  margin-bottom: 1rem;
}
.batch-actions .batch-actions-bar {
  padding: 0.25rem 0rem;
  max-height: 28px;
  min-height: 28px;
}
.batch-actions .batch-actions-bar .selected-vehicles-info .badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}
.batch-actions .batch-actions-bar .btn-white-text {
  color: white !important;
}
.batch-actions .alert {
  margin-bottom: 0;
}

.vehicle-table-container {
  margin-bottom: 2rem;
  overflow-x: auto;
}
.vehicle-table-container .select-all-container {
  padding: 0.5rem 0;
}
.vehicle-table-container .select-all-container .form-check {
  display: flex;
  align-items: center;
}
.vehicle-table-container .select-all-container .form-check .form-check-input {
  margin-right: 0.5rem;
}
.vehicle-table-container .select-all-container .form-check .form-check-label {
  font-weight: 500;
}
.vehicle-table-container .table {
  min-width: 1000px;
}
.vehicle-table-container .table th, .vehicle-table-container .table td {
  vertical-align: middle;
  padding: 5px !important;
}
.vehicle-table-container .table .select-column {
  position: relative;
  z-index: 10;
}
.vehicle-table-container .table .select-column .form-check {
  position: relative;
  z-index: 11;
}
.vehicle-table-container .table .select-column .form-check .form-check-input {
  opacity: 1 !important;
  position: relative;
  z-index: 12;
  pointer-events: auto !important;
}
.vehicle-table-container .table .select-column {
  width: 50px;
  min-width: 50px;
  max-width: 50px;
  text-align: center;
  padding: 8px;
}
.vehicle-table-container .table .select-column .form-check {
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 20px;
}
.vehicle-table-container .table .select-column .form-check .form-check-input {
  margin: 0;
  width: 18px;
  height: 18px;
  border: 2px solid #6c757d;
  border-radius: 3px;
  background-color: #fff;
  cursor: pointer;
}
.vehicle-table-container .table .image-column {
  width: 100px;
}
.vehicle-table-container .table .image-column .image-container {
  position: relative;
  display: inline-block;
}
.vehicle-table-container .table .image-column .image-container.clickable {
  cursor: pointer;
}
.vehicle-table-container .table .image-column .image-container.clickable:hover .vehicle-thumbnail {
  opacity: 0.8;
  transform: scale(1.05);
}
.vehicle-table-container .table .image-column .image-container.clickable:hover .image-overlay {
  opacity: 1;
}
.vehicle-table-container .table .image-column .vehicle-thumbnail {
  width: 80px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  transition: opacity 0.2s, transform 0.2s;
  display: block;
}
.vehicle-table-container .table .image-column .image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 123, 255, 0.9);
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  opacity: 0;
  transition: opacity 0.2s;
  font-size: 0.7rem;
}
.vehicle-table-container .table .image-column .image-overlay i {
  font-size: 1rem;
  margin-bottom: 2px;
}
.vehicle-table-container .table .image-column .image-overlay span {
  font-weight: 500;
}
.vehicle-table-container .table .vehicle-info-column {
  min-width: 150px;
}
.vehicle-table-container .table .vehicle-info-column.clickable {
  cursor: pointer;
  transition: background-color 0.2s;
}
.vehicle-table-container .table .vehicle-info-column.clickable:hover {
  background-color: rgba(0, 123, 255, 0.05);
}
.vehicle-table-container .table .vehicle-info-column .vehicle-name {
  font-weight: 600;
  margin-bottom: 0.25rem;
}
.vehicle-table-container .table .vehicle-info-column .vehicle-variant {
  font-size: 0.8rem;
  color: #6c757d;
  margin-bottom: 0.25rem;
}
.vehicle-table-container .table .vehicle-info-column .importing-badge {
  margin-left: 0.5rem;
}
.vehicle-table-container .table .vehicle-info-column .importing-badge .fa-spinner {
  font-size: 0.9rem;
}
.vehicle-table-container .table .specs-column {
  min-width: 180px;
  font-size: 0.85rem;
  white-space: normal;
  line-height: 1.3;
}
.vehicle-table-container .table .price-column {
  min-width: 100px;
  font-weight: 600;
}
.vehicle-table-container .table .date-column {
  min-width: 140px;
  font-size: 0.85rem;
  white-space: nowrap;
}
.vehicle-table-container .table .reserve-price-column .editable-field {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}
.vehicle-table-container .table .reserve-price-column .editable-field:hover {
  background-color: rgba(0, 123, 255, 0.1);
}
.vehicle-table-container .table .reserve-price-column .editable-field .edit-icon {
  margin-left: 6px;
  font-size: 0.8rem;
  color: #6c757d;
  opacity: 0.7;
}
.vehicle-table-container .table .reserve-price-column .editable-field:hover .edit-icon {
  opacity: 1;
  color: #007bff;
}
.vehicle-table-container .table .status-column {
  min-width: 120px;
}
.vehicle-table-container .table .status-column .status-badge {
  display: inline-block;
  margin-bottom: 0.25rem;
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}
.vehicle-table-container .table .status-column .new-badge {
  margin-left: 0.25rem;
}
.vehicle-table-container .table .actions-column {
  min-width: 120px;
  white-space: nowrap;
  text-align: center;
}
.vehicle-table-container .table .actions-column .importing-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
}
.vehicle-table-container .table .actions-column .importing-indicator .badge {
  font-size: 0.75rem;
  padding: 0.5rem 0.75rem;
}
.vehicle-table-container .table .actions-column .importing-indicator .badge .fa-spinner {
  margin-right: 0.25rem;
}
.vehicle-table-container .table .actions-column .btn-white-text {
  color: white !important;
}

h2 {
  font-size: 28px;
  letter-spacing: -1px;
}

.pagination-controls .pagination {
  font-size: 1.2rem;
}
.pagination-controls .pagination .page-link {
  color: #007bff;
  padding: 0.5rem 0.75rem;
}
.pagination-controls .pagination .page-link:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.pagination-controls .pagination .page-item.active .page-link {
  background-color: #007bff;
  border-color: #007bff;
  font-weight: bold;
}

.status-badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  display: inline-block;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
}

.modal-backdrop {
  z-index: 1040;
}

.modal {
  z-index: 1050;
}

.vehicle-image-carousel .current-image-container {
  position: relative;
  margin-bottom: 1rem;
}
.vehicle-image-carousel .current-image-container .vehicle-detail-image {
  height: 300px;
  object-fit: cover;
  border-radius: 0.375rem;
  border: 1px solid #dee2e6;
  width: 100%;
}
.vehicle-image-carousel .no-image-placeholder .vehicle-detail-image {
  height: 300px;
  object-fit: contain;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}
.vehicle-image-carousel .carousel-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding: 0 1rem;
}
.vehicle-image-carousel .carousel-controls .carousel-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.vehicle-image-carousel .carousel-controls .carousel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.vehicle-image-carousel .carousel-controls .image-counter {
  font-weight: 500;
  color: #495057;
  font-size: 0.9rem;
}
.vehicle-image-carousel .thumbnail-nav {
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  padding: 0.5rem 0;
}
.vehicle-image-carousel .thumbnail-nav .thumbnail-item {
  flex-shrink: 0;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 0.25rem;
  overflow: hidden;
  transition: border-color 0.2s;
}
.vehicle-image-carousel .thumbnail-nav .thumbnail-item.active {
  border-color: #007bff;
}
.vehicle-image-carousel .thumbnail-nav .thumbnail-item:hover {
  border-color: #6c757d;
}
.vehicle-image-carousel .thumbnail-nav .thumbnail-item .thumbnail-image {
  width: 60px;
  height: 45px;
  object-fit: cover;
  display: block;
}

.vehicle-details h6 {
  color: #495057;
  font-weight: 600;
  margin-bottom: 1rem;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 0.5rem;
}
.vehicle-details .table {
  margin-bottom: 0;
}
.vehicle-details .table td {
  padding: 0.5rem 0.75rem;
  border-top: 1px solid #dee2e6;
}
.vehicle-details .table td:first-child {
  width: 40%;
  background-color: #f8f9fa;
}
.vehicle-details .table tr:first-child td {
  border-top: none;
}

@media (max-width: 768px) {
  .dashboard-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .dashboard-header .user-controls {
    margin-top: 1rem;
    width: 100%;
  }
  .dashboard-header .user-controls button {
    width: 100%;
  }
  .search-filter-bar form {
    flex-direction: column;
  }
  .search-filter-bar form .col-md-4, .search-filter-bar form .col-md-3, .search-filter-bar form .col-md-2 {
    width: 100%;
    margin-bottom: 1rem;
  }
}
.vrm {
  font-weight: bold;
  text-transform: uppercase;
  background-color: lightgoldenrodyellow;
  padding: 0 5px;
  display: inline-block;
  margin-bottom: 7px;
  border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/admin/vehicle/vehicle-import-management/vehicle-management-dashboard/vehicle-management-dashboard.component.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,2BAAA;EACA,qBAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,OAAA;EACA,gBAAA;EAEA,2BAAA;EACA,qBAAA;AADJ;AAGI;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AADN;AAII;EACE,YAAA;AAFN;AAKI;EAEE,aAAA;EACA,oBAAA;AAJN;AAMM;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;AAJR;AAMQ;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;AAJV;AAOQ;EACE,YAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,0CAAA;AALV;AAaQ;;EAEE,wBAAA;EACA,QAAA;EACA,UAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAXV;AAaU;;EACE,gBAAA;EACA,8CAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAVZ;AAkBE;EACE;IACE,gBAAA;IACA,eAAA;EAhBJ;AACF;AAmBE;EACE;IACE,eAAA;IACA,eAAA;EAjBJ;AACF;;AAqBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;AAlBF;AAoBE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;AAlBJ;;AAsBA;EACE,qBAAA;AAnBF;AAqBE;EACE,gCAAA;AAnBJ;AAqBI;EACE,eAAA;EACA,cAAA;EACA,6BAAA;EACA,+BAAA;EACA,gCAAA;EACA,wBAAA;EACA,gBAAA;AAnBN;AAqBM;EACE,qCAAA;AAnBR;AAsBM;EACE,cAAA;EACA,sBAAA;EACA,kCAAA;AApBR;;AA0BA;EACE,yBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yCAAA;AAvBF;;AA0BA;EACE,mBAAA;AAvBF;AAyBE;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;AAvBJ;AA0BM;EACE,kBAAA;EACA,uBAAA;AAxBR;AA4BI;EACE,uBAAA;AA1BN;AA8BE;EACE,gBAAA;AA5BJ;;AAgCA;EACE,mBAAA;EACA,gBAAA;AA7BF;AA+BE;EACE,iBAAA;AA7BJ;AA+BI;EACE,aAAA;EACA,mBAAA;AA7BN;AA+BM;EACE,oBAAA;AA7BR;AAgCM;EACE,gBAAA;AA9BR;AAmCE;EACE,iBAAA;AAjCJ;AAmCI;EACE,sBAAA;EACA,uBAAA;AAjCN;AAoCI;EACE,kBAAA;EACA,WAAA;AAlCN;AAoCM;EACE,kBAAA;EACA,WAAA;AAlCR;AAoCQ;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,+BAAA;AAlCV;AAuCI;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AArCN;AAuCM;EACE,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AArCR;AAuCQ;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AArCV;AAoDI;EACE,YAAA;AAlDN;AAoDM;EACE,kBAAA;EACA,qBAAA;AAlDR;AAoDQ;EACE,eAAA;AAlDV;AAqDY;EACE,YAAA;EACA,sBAAA;AAnDd;AAsDY;EACE,UAAA;AApDd;AA0DM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,wCAAA;EACA,cAAA;AAxDR;AA2DM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,wBAAA;EACA,iBAAA;AAzDR;AA2DQ;EACE,eAAA;EACA,kBAAA;AAzDV;AA4DQ;EACE,gBAAA;AA1DV;AA+DI;EACE,gBAAA;AA7DN;AA+DM;EACE,eAAA;EACA,iCAAA;AA7DR;AA+DQ;EACE,yCAAA;AA7DV;AAiEM;EACE,gBAAA;EACA,sBAAA;AA/DR;AAkEM;EACE,iBAAA;EACA,cAAA;EACA,sBAAA;AAhER;AAmEM;EACE,mBAAA;AAjER;AAmEQ;EACE,iBAAA;AAjEV;AAsEI;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AApEN;AAuEI;EACE,gBAAA;EACA,gBAAA;AArEN;AAwEI;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;AAtEN;AA0EM;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;AAxER;AA0EQ;EACE,wCAAA;AAxEV;AA2EQ;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AAzEV;AA4EQ;EACE,UAAA;EACA,cAAA;AA1EV;AA+EI;EACE,gBAAA;AA7EN;AA+EM;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;AA7ER;AAgFM;EACE,oBAAA;AA9ER;AAkFI;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;AAhFN;AAkFM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAhFR;AAkFQ;EACE,kBAAA;EACA,uBAAA;AAhFV;AAkFU;EACE,qBAAA;AAhFZ;AAqFM;EACE,uBAAA;AAnFR;;AAyFA;EACE,eAAA;EACA,oBAAA;AAtFF;;AA0FE;EACE,iBAAA;AAvFJ;AAyFI;EACE,cAAA;EACA,uBAAA;AAvFN;AAyFM;EACE,gDAAA;AAvFR;AA2FI;EACE,yBAAA;EACA,qBAAA;EACA,iBAAA;AAzFN;;AA+FA;EACE,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;AA5FF;;AAgGA;EACE,aAAA;AA7FF;;AAgGA;EACE,aAAA;AA7FF;;AAkGE;EACE,kBAAA;EACA,mBAAA;AA/FJ;AAiGI;EACE,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;AA/FN;AAoGI;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;AAlGN;AAsGE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AApGJ;AAsGI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AApGN;AAsGM;EACE,YAAA;EACA,mBAAA;AApGR;AAwGI;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;AAtGN;AA0GE;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AAxGJ;AA0GI;EACE,cAAA;EACA,eAAA;EACA,6BAAA;EACA,sBAAA;EACA,gBAAA;EACA,6BAAA;AAxGN;AA0GM;EACE,qBAAA;AAxGR;AA2GM;EACE,qBAAA;AAzGR;AA4GM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AA1GR;;AAiHE;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCAAA;EACA,sBAAA;AA9GJ;AAiHE;EACE,gBAAA;AA/GJ;AAiHI;EACE,uBAAA;EACA,6BAAA;AA/GN;AAiHM;EACE,UAAA;EACA,yBAAA;AA/GR;AAmHI;EACE,gBAAA;AAjHN;;AAuHA;EACE;IACE,sBAAA;IACA,uBAAA;EApHF;EAsHE;IACE,gBAAA;IACA,WAAA;EApHJ;EAsHI;IACE,WAAA;EApHN;EA0HE;IACE,sBAAA;EAxHJ;EA0HI;IACE,WAAA;IACA,mBAAA;EAxHN;AACF;AAkIA;EACE,iBAAA;EACA,yBAAA;EACA,sCAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAhIF","sourcesContent":["// Filters Container - Flexbox Layout\n.filters-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: flex-start;\n  margin-bottom: 1.5rem;\n\n  .filter-item {\n    display: flex;\n    flex-direction: row;\n    min-width: 200px;\n    flex: 1;\n    max-width: 300px;\n\n    justify-content: flex-start;\n    align-items: baseline;\n\n    .filter-label {\n      font-size: 0.875rem;\n      font-weight: 500;\n      color: #495057;\n      margin-bottom: 0.25rem;\n      white-space: nowrap;\n    }\n\n    .form-control {\n      height: 38px;\n    }\n\n    .select {\n      // Ensure the select wrapper aligns with other form controls\n      display: flex;\n      align-items: stretch;\n\n      mdb-select-2 {\n        height: 38px;\n        width: 100%;\n        min-width: 160px;\n        display: inline-block;\n\n        .select-wrapper {\n          margin-bottom: 0;\n          height: 38px;\n          display: flex;\n          align-items: stretch;\n        }\n\n        .form-control {\n          height: 38px;\n          border: 1px solid #ced4da;\n          border-radius: 0.375rem;\n          line-height: 1.5;\n          padding: 0.375rem 2.25rem 0.375rem 0.75rem;\n\n          //&:focus {\n          //  border-color: #007bff;\n          //  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n          //}\n        }\n\n        .mdb-select-arrow,\n        .mdb-select-toggle {\n          height: calc(100% - 2px);\n          top: 1px;\n          right: 1px;\n          border-left: 1px solid #ced4da;\n          width: 36px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n\n          &::before {\n            content: '\\f107';\n            font-family: 'Font Awesome 5 Free', ui-rounded;\n            font-weight: 900;\n            color: #6c757d;\n            font-size: 14px;\n          }\n        }\n      }\n    }\n  }\n\n  // Responsive behavior\n  @media (max-width: 768px) {\n    .filter-item {\n      min-width: 150px;\n      max-width: 100%;\n    }\n  }\n\n  @media (max-width: 576px) {\n    .filter-item {\n      min-width: 100%;\n      max-width: 100%;\n    }\n  }\n}\n\n.dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n\n  h1 {\n    margin: 0;\n    font-size: 1.75rem;\n    font-weight: 600;\n  }\n}\n\n.filter-tabs {\n  margin-bottom: 1.5rem;\n\n  .nav-tabs {\n    border-bottom: 1px solid #dee2e6;\n\n    .nav-link {\n      cursor: pointer;\n      color: #495057;\n      border: 1px solid transparent;\n      border-top-left-radius: 0.25rem;\n      border-top-right-radius: 0.25rem;\n      padding: 0.75rem 1.25rem;\n      font-weight: 500;\n\n      &:hover {\n        border-color: #e9ecef #e9ecef #dee2e6;\n      }\n\n      &.active {\n        color: #007bff;\n        background-color: #fff;\n        border-color: #dee2e6 #dee2e6 #fff;\n      }\n    }\n  }\n}\n\n.search-filter-bar {\n  background-color: #f8f9fa;\n  padding: 1.25rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.batch-actions {\n  margin-bottom: 1rem;\n\n  .batch-actions-bar {\n    padding: 0.25rem 0rem;\n    max-height: 28px;\n    min-height: 28px;\n\n    .selected-vehicles-info {\n      .badge {\n        font-size: 0.75rem;\n        padding: 0.25rem 0.5rem;\n      }\n    }\n\n    .btn-white-text {\n      color: white !important;\n    }\n  }\n\n  .alert {\n    margin-bottom: 0;\n  }\n}\n\n.vehicle-table-container {\n  margin-bottom: 2rem;\n  overflow-x: auto;\n\n  .select-all-container {\n    padding: 0.5rem 0;\n\n    .form-check {\n      display: flex;\n      align-items: center;\n\n      .form-check-input {\n        margin-right: 0.5rem;\n      }\n\n      .form-check-label {\n        font-weight: 500;\n      }\n    }\n  }\n\n  .table {\n    min-width: 1000px;\n\n    th, td {\n      vertical-align: middle;\n      padding: 5px !important;\n    }\n\n    .select-column {\n      position: relative;\n      z-index: 10; // Bring the entire column forward\n\n      .form-check {\n        position: relative;\n        z-index: 11;\n\n        .form-check-input {\n          opacity: 1 !important;\n          position: relative;\n          z-index: 12; // Highest z-index for the checkbox\n          pointer-events: auto !important; // Force pointer events\n        }\n      }\n    }\n\n    .select-column {\n      width: 50px;\n      min-width: 50px;\n      max-width: 50px;\n      text-align: center;\n      padding: 8px;\n\n      .form-check {\n        margin: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        min-height: 20px;\n\n        .form-check-input {\n          margin: 0;\n          width: 18px;\n          height: 18px;\n          border: 2px solid #6c757d;\n          border-radius: 3px;\n          background-color: #fff;\n          cursor: pointer;\n\n          //&:checked {\n          //  background-color: #007bff;\n          //  border-color: #007bff;\n          //}\n\n          //&:focus {\n          //  border-color: #007bff;\n          //  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n          //}\n        }\n      }\n    }\n\n    .image-column {\n      width: 100px;\n\n      .image-container {\n        position: relative;\n        display: inline-block;\n\n        &.clickable {\n          cursor: pointer;\n\n          &:hover {\n            .vehicle-thumbnail {\n              opacity: 0.8;\n              transform: scale(1.05);\n            }\n\n            .image-overlay {\n              opacity: 1;\n            }\n          }\n        }\n      }\n\n      .vehicle-thumbnail {\n        width: 80px;\n        height: 60px;\n        object-fit: cover;\n        border-radius: 4px;\n        transition: opacity 0.2s, transform 0.2s;\n        display: block;\n      }\n\n      .image-overlay {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: rgba(0, 123, 255, 0.9);\n        color: white;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        border-radius: 4px;\n        opacity: 0;\n        transition: opacity 0.2s;\n        font-size: 0.7rem;\n\n        i {\n          font-size: 1rem;\n          margin-bottom: 2px;\n        }\n\n        span {\n          font-weight: 500;\n        }\n      }\n    }\n\n    .vehicle-info-column {\n      min-width: 150px;\n\n      &.clickable {\n        cursor: pointer;\n        transition: background-color 0.2s;\n\n        &:hover {\n          background-color: rgba(0, 123, 255, 0.05);\n        }\n      }\n\n      .vehicle-name {\n        font-weight: 600;\n        margin-bottom: 0.25rem;\n      }\n\n      .vehicle-variant {\n        font-size: 0.8rem;\n        color: #6c757d;\n        margin-bottom: 0.25rem;\n      }\n\n      .importing-badge {\n        margin-left: 0.5rem;\n\n        .fa-spinner {\n          font-size: 0.9rem;\n        }\n      }\n    }\n\n    .specs-column {\n      min-width: 180px;\n      font-size: 0.85rem;\n      white-space: normal;\n      line-height: 1.3;\n    }\n\n    .price-column {\n      min-width: 100px;\n      font-weight: 600;\n    }\n\n    .date-column {\n      min-width: 140px;\n      font-size: 0.85rem;\n      white-space: nowrap;\n    }\n\n    .reserve-price-column {\n      .editable-field {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        padding: 4px 8px;\n        border-radius: 4px;\n        transition: background-color 0.2s;\n\n        &:hover {\n          background-color: rgba(0, 123, 255, 0.1);\n        }\n\n        .edit-icon {\n          margin-left: 6px;\n          font-size: 0.8rem;\n          color: #6c757d;\n          opacity: 0.7;\n        }\n\n        &:hover .edit-icon {\n          opacity: 1;\n          color: #007bff;\n        }\n      }\n    }\n\n    .status-column {\n      min-width: 120px;\n\n      .status-badge {\n        display: inline-block;\n        margin-bottom: 0.25rem;\n        font-size: 0.75rem;\n        padding: 0.25rem 0.5rem;\n      }\n\n      .new-badge {\n        margin-left: 0.25rem;\n      }\n    }\n\n    .actions-column {\n      min-width: 120px;\n      white-space: nowrap;\n      text-align: center;\n\n      .importing-indicator {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        .badge {\n          font-size: 0.75rem;\n          padding: 0.5rem 0.75rem;\n\n          .fa-spinner {\n            margin-right: 0.25rem;\n          }\n        }\n      }\n\n      .btn-white-text {\n        color: white !important;\n      }\n    }\n  }\n}\n\nh2 {\n  font-size: 28px;\n  letter-spacing: -1px;\n}\n\n.pagination-controls {\n  .pagination {\n    font-size: 1.2rem;\n\n    .page-link {\n      color: #007bff;\n      padding: 0.5rem 0.75rem;\n\n      &:focus {\n        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n      }\n    }\n\n    .page-item.active .page-link {\n      background-color: #007bff;\n      border-color: #007bff;\n      font-weight: bold;\n    }\n  }\n}\n\n// Status badge styles\n.status-badge {\n  font-size: 0.75rem;\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n  display: inline-block;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n}\n\n// Modal styles\n.modal-backdrop {\n  z-index: 1040;\n}\n\n.modal {\n  z-index: 1050;\n}\n\n// Vehicle Details Modal\n.vehicle-image-carousel {\n  .current-image-container {\n    position: relative;\n    margin-bottom: 1rem;\n\n    .vehicle-detail-image {\n      height: 300px;\n      object-fit: cover;\n      border-radius: 0.375rem;\n      border: 1px solid #dee2e6;\n      width: 100%;\n    }\n  }\n\n  .no-image-placeholder {\n    .vehicle-detail-image {\n      height: 300px;\n      object-fit: contain;\n      background-color: #f8f9fa;\n      border: 1px solid #dee2e6;\n    }\n  }\n\n  .carousel-controls {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1rem;\n    padding: 0 1rem;\n\n    .carousel-btn {\n      width: 40px;\n      height: 40px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n    }\n\n    .image-counter {\n      font-weight: 500;\n      color: #495057;\n      font-size: 0.9rem;\n    }\n  }\n\n  .thumbnail-nav {\n    display: flex;\n    gap: 0.5rem;\n    overflow-x: auto;\n    padding: 0.5rem 0;\n\n    .thumbnail-item {\n      flex-shrink: 0;\n      cursor: pointer;\n      border: 2px solid transparent;\n      border-radius: 0.25rem;\n      overflow: hidden;\n      transition: border-color 0.2s;\n\n      &.active {\n        border-color: #007bff;\n      }\n\n      &:hover {\n        border-color: #6c757d;\n      }\n\n      .thumbnail-image {\n        width: 60px;\n        height: 45px;\n        object-fit: cover;\n        display: block;\n      }\n    }\n  }\n}\n\n.vehicle-details {\n  h6 {\n    color: #495057;\n    font-weight: 600;\n    margin-bottom: 1rem;\n    border-bottom: 1px solid #dee2e6;\n    padding-bottom: 0.5rem;\n  }\n\n  .table {\n    margin-bottom: 0;\n\n    td {\n      padding: 0.5rem 0.75rem;\n      border-top: 1px solid #dee2e6;\n\n      &:first-child {\n        width: 40%;\n        background-color: #f8f9fa;\n      }\n    }\n\n    tr:first-child td {\n      border-top: none;\n    }\n  }\n}\n\n// Responsive adjustments\n@media (max-width: 768px) {\n  .dashboard-header {\n    flex-direction: column;\n    align-items: flex-start;\n\n    .user-controls {\n      margin-top: 1rem;\n      width: 100%;\n\n      button {\n        width: 100%;\n      }\n    }\n  }\n\n  .search-filter-bar {\n    form {\n      flex-direction: column;\n\n      .col-md-4, .col-md-3, .col-md-2 {\n        width: 100%;\n        margin-bottom: 1rem;\n      }\n    }\n  }\n}\n\n// Accessibility focus styles\n//button:focus, a:focus, input:focus, select:focus {\n//  outline: 2px solid #007bff;\n//  outline-offset: 2px;\n//}\n.vrm {\n  font-weight: bold;\n  text-transform: uppercase;\n  background-color: lightgoldenrodyellow;\n  padding: 0 5px;\n  display: inline-block;\n  margin-bottom: 7px;\n  border-radius: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
